import { Box } from '@mui/material';

import { CohortsListPageContent } from '../containers/CohortsListPageContent/CohortsListPageContent';
import { CohortsListPageHeader } from '../containers/CohortsListPageHeader/CohortsListPageHeader';
import { CohortModalProvider } from '../context/modalContext';

export const CohortListPage = () => {
  return (
    <CohortModalProvider>
      <Box>
        <CohortsListPageHeader />
        <CohortsListPageContent />
      </Box>
    </CohortModalProvider>
  );
};
